import { DetectionStatus } from '../types/detection-status.js';

type BadgeVariant =
  'default' | 'success' | 'destructive' | 'secondary' | 'outline' | 'warning' | 'warning-light';

export const getStatusVariant = (status: DetectionStatus): BadgeVariant => {
  switch (status) {
    case DetectionStatus.DETECTED:
      return 'default';
    case DetectionStatus.SUPPRESSION_SUCCESS:
      return 'success';
    case DetectionStatus.SUPPRESSION_FAILED:
      return 'destructive';
    case DetectionStatus.SUPPRESSION_IN_PROGRESS:
      return 'warning';
    case DetectionStatus.WHITELISTED:
      return 'outline';
    case DetectionStatus.LOST:
      return 'secondary';
    case DetectionStatus.SUPPRESSION_INITIATED:
      return 'warning-light';
    default:
      return 'default';
  }
};

export const getStatusTranslationKey = (status: DetectionStatus): string => {
  switch (status) {
    case DetectionStatus.DETECTED:
      return 'detectionStatus.detected';
    case DetectionStatus.SUPPRESSION_SUCCESS:
      return 'detectionStatus.suppressionSuccess';
    case DetectionStatus.SUPPRESSION_FAILED:
      return 'detectionStatus.suppressionFailed';
    case DetectionStatus.SUPPRESSION_INITIATED:
      return 'detectionStatus.suppressionInitiated';
    case DetectionStatus.SUPPRESSION_IN_PROGRESS:
      return 'detectionStatus.suppressionInProgress';
    case DetectionStatus.WHITELISTED:
      return 'detectionStatus.whitelisted';
    case DetectionStatus.LOST:
      return 'detectionStatus.lost';
    default:
      return 'detectionStatus.unknown';
  }
};
